
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'LaryngealObstruction',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/LaryngealObstruction.vue